import * as React from 'react';
import ReactDOM from 'react-dom';
import { configure } from 'mobx';
configure({ enforceActions: 'observed', isolateGlobalState: true });

import { Provider } from 'mobx-react';
import { MainStore } from './stores/MainStore';
import { IContextData,IResponseData } from './stores/types';
import DetailsPageLayout from './components/detailsPage/detailsPageLayout';
import './thirdPartyStyles/styles';
import { installConsoleOverlay } from './helper/consoleOverlay';
/* eslint-disable no-console */

// best-effort pageview logging (non-blocking)
function logPageLoad(state: IResponseData): void {
    try {
        const apiUrl = state?.contextData?.apiLink + 'productdetailspage/pageload';
        const requestUrl = new URL(apiUrl);
        const customerNumber = state.contextData.customerData?.customerNumbers?.length > 0 ?
            state.contextData.customerData.customerNumbers[0] : null;
        const body = {
            articleInfo: state.orderModule.articleInfo,
            category: state.breadcrumb.category,
            customerNumber: customerNumber
        };

        // Append all query parameters from the current browser URL
        if (typeof window !== 'undefined') {
            const currentUrl = new URL(window.location.href);

            currentUrl.searchParams.forEach((value, key) => {
                requestUrl.searchParams.append(key, value);
            });
        }

        fetch(requestUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(body)
        }).catch(() => { /* ignore */ });
    } catch {
        // ignore
    }
}

function hydrateApp() {
    const state = JSON.parse(JSON.stringify(window.__PRELOADED_PDP_STATE__));
    const store: MainStore = new MainStore(state.otherData, state.localization);
    delete window.__PRELOADED_PDP_STATE__;
    const container = document.getElementById('product-details-page-entry');

    if (!container) {
        throw new Error('product-details-page-entry root container element not found');
    }

    if (container) {
        ReactDOM.hydrate(
                <Provider
                    store={store}
                    orderModuleStore={store.orderModuleStore}
                    mixedMediaStore={store.mixedMediaStore}
                    variantStore={store.variantStore}
                    workWearStoreStore={store.workWearStoreStore}
                    dataStore={store.dataStore}
                >
                    <DetailsPageLayout />
                </Provider>, container
        );
    }
}

const state = JSON.parse(JSON.stringify(window.__PRELOADED_PDP_STATE__));
const context: IContextData = state.otherData.contextData;
if (context.isEsApp && !context.isRelease) {
    installConsoleOverlay({ openOnError: false, addTripleTapToToggle: true });
}

if (context.featureToggles.enableContentServiceForPDP) {
    logPageLoad(state.otherData);
}

try {
    hydrateApp();
} catch (e) {
    console.error('HYDRATION CRASH: ' + e.message);
}


